// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-top-products/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { ShoppingBag as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetTopProductsMeta: TWidgetMetaInfo = {
  name: 'Top Products',
  categories: ['Chart'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'Shows a chart with information about the most sold products.',
  externalDependencies: [],
}
